// Import the RTK Query methods from the React-specific entry point
import {
  fetchBaseQuery,
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError
} from "@reduxjs/toolkit/query/react"
import { RTK_SLICE_API_LIST } from "../../common/constants"
import { setSessionExpired } from "../slices/auth"

const axiosBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_HOST ?? "/",
  credentials: "include",
  prepareHeaders: (headers: Headers, { getState }: any) => {
    const token = getState().auth.user?.sessid
    if (token) {
      headers.set("Authorization", token)
    }
    return headers
  }
})

export const baseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await axiosBaseQuery(args, api, extraOptions)

  if (
    result.data &&
    (result.data as any)?.status === "error" &&
    (result.data as any)?.message === "not allowed to do that"
  ) {
    // Only show the session expired modal if we're not already on the login page
    const currentPath = window.location.pathname
    if (!currentPath.startsWith("/user/login")) {
      // This is our ambiguous error. We can't know for sure if it's an expired
      // session or a permissions issue, so we dispatch to show the modal.
      api.dispatch(setSessionExpired(true))
    }
  }

  return result
}

export const getTags = (reducerPath: string, key: string, result?: any[]) => [
  ...(result ?? []).map(
    item =>
      ({
        type: reducerPath as any,
        id: item[key]
      } as const)
  ),
  { type: reducerPath as any, id: RTK_SLICE_API_LIST }
]
